import CampaignSetup from '../views/CampaignSetup.vue'
import CampaignsView from '../views/CampaignsView.vue'
import MyCampaignsView from '../views/MyCampaignsView.vue'
import CharactersView from '../views/CharactersView.vue'
import CharacterSheetView from '../views/CharacterSheetView.vue'
//----------------------------
// routes
//----------------------------
export default [
  {
    path: '/character-sheet',
    name: 'CharacterSheetView',
    component: CharacterSheetView,
    meta: { title: 'Character Sheet', requiresAuth: true },
  },
  {
    path: '/my-characters',
    name: 'myCharactersView',
    component: CharactersView,
    props: { listScope: 'mine' },
    meta: { title: 'My Characters', requiresAuth: true },
  },
  {
    path: '/my-campaigns',
    name: 'myCampaignsView',
    component: MyCampaignsView,
    meta: { title: 'My Campaigns', requiresAuth: true },
  },
  //   {
  //   path: '/campaigns',
  //   name: 'campaignsView',
  //   component: CampaignsView,
  //   meta: { title: 'Campaigns', requiresAuth: true },
  // },
  {
    path: '/campaigns/:campaign_name?/:action?',
    name: 'campaignsView',
    component: CampaignsView,
    props: true,
    meta: { title: 'Campaigns', requiresAuth: true },
  },
  {
    path: '/campaign-setup/:slug?',
    name: 'campaignSetup',
    component: CampaignSetup,
    props: true,
    meta: { title: 'Campaign Setup', requiresAuth: true },
  },
]
